const resources = {
    shopThisPost: 'Découvrir cette publication'
};

export default function getResource(label) {
    return resources[label];
}
